import React from "react"
import { Text, Box, AspectRatio, GridItem, Heading, Stack, Button } from "@chakra-ui/react"

import { useImage } from "@hooks/useImage"
import { useRoutes } from "@hooks/useRoutes"
import Image from "@components/Image/Image"
import Link from "@components/Link"

export interface FeaturedLearnItemProps {
  item?: GatsbyTypes.SanityLearnPageItem
  handleTrackingClick: VoidFunction
}

const FeaturedLearnItem = ({ item, handleTrackingClick }: FeaturedLearnItemProps) => {
  const { getGatsbyImage } = useImage()
  const { urlResolver } = useRoutes()

  const image = getGatsbyImage(item?.Page?.image)
  const link = urlResolver(item?.Page)

  return (
    <GridItem as="article" textAlign="center">
      <Stack alignItems="center" spacing={2}>
        <AspectRatio ratio={[343 / 294, 427 / 453]} w="full">
          <Image {...image} borderRadius={`sm`} />
        </AspectRatio>
        <Box>
          <Heading as="h4" size="h4" fontWeight="semibold" display={["none", "block"]} mb={1}>
            {item?.Page?.title}
          </Heading>
          <Heading as="h3" size="h3" fontWeight="regular" display={["block", "none"]}>
            {item?.Page?.title}
          </Heading>
          <Text>{item?.Page?.description}</Text>
        </Box>
        <Button variant="blue" as={Link} px={2.5} to={link?.url} onClick={handleTrackingClick}>
          {item?.buttonLabel}
        </Button>
      </Stack>
    </GridItem>
  )
}

export default React.memo(FeaturedLearnItem)
